<template>
  <div>
    <div class="app-panel-row border-radius">
      <div class="d-inline-block lighter">
        {{ $t('vSTAGELoginScreen') }}:<br />{{ appPanelUrl ? appPanelUrl : 'default' }}
        <div
          v-if="!appPanelEditing && !readOnly"
          @click="appPanelEditing = true"
          class="d-inline-block clickable lighter ml-1">
        <icon size="0.9" type="pencil-alt" />
      </div>
      </div>
      <div v-if="appPanelEditing" class="row">
        <div class="col-6">
          <label class="vform-label white mb-0">{{ $t('manual') }}</label>
          <input
              type="text"
              v-model="appPanelUrlLocal"
              class="form-text form-text-dark w-100"
          />
        </div>
        <div class="col-6">
          <label class="vform-label white mb-0">{{ $t('select') }}</label>
          <universal-selector
              :limit-by-organization-id="organizationId"
              include="instances"
              list-name="apps"
              store-name="App"
              @addItem="setAppPanel"
          />
        </div>
        <div class="col-12 mt-2">
          <div
              @click="setAppPanelUrl"
              class="settings-button d-inline-block">
            {{ $t('save') }}
          </div>
          <div
              @click="appPanelEditing = false"
              class="settings-button d-inline-block ml-2">
            {{ $t('abort') }}
          </div>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";
import UniversalSelector from "@/components/organizations/UniversalSelector.vue";
import {filterByAppPanelOnly} from "@/utils";
export default {
  name: "UserAppPanelEditor",
  components: {
    UniversalSelector,
    Icon
  },
  props: {
    appPanelUrl: {type: String, default: ''},
    organizationId: {type: String, required: true},
    readOnly: {type: Boolean, default: false},
  },
  data() {
    return {
      appPanelEditing: false,
      appPanelUrlLocal: this.appPanelUrl || '',
    };
  },
  mounted() {
    this.appPanelUrlLocal = this.appPanelUrl || '';
  },
  methods: {
    setAppPanelUrl() {
      this.$emit('updateAppPanel', this.appPanelUrlLocal);
      this.appPanelEditing = false;
    },
    setAppPanel(item) {
      fetch(process.env.VUE_APP_CONFIG)
          .then(r => r.json())
          .then(async config => {
            const baseURL = config.sfx.project.webapp.appHost;
            let appPanel = baseURL + '/' + item.slug;

            // this is for legacy reason, remove when app panel webapp gets retired
            const res = filterByAppPanelOnly(item);
            if(!res) {
              appPanel = baseURL + '/' + item.slug + '/#/app-overview';
            }
            this.$emit('updateAppPanel', appPanel);
            this.appPanelEditing = false;
          });
    },
  }
}
</script>

<style lang="scss" scoped>
.app-panel-row {
  background-color: var(--vform-editor-ui-quinary-color);
  padding: 5px;
}
</style>